import { StorageSerializers } from '@vueuse/core'

import type { SessionType } from '~/types'

import type { BuilderAuthData } from './api/internal/builder-session/useFetchBuilderSession'
import type { BrowserAuthData } from './api/internal/browser-session/useFetchBrowserSession'

export const useSessionStorageAuth = (sessionType: SessionType) => {
  const authData = useSessionStorage<BuilderAuthData | BrowserAuthData | null>(
    `session_access_${sessionType}`,
    null,
    { serializer: StorageSerializers.object },
  )
  return { authData }
}
